module.exports = __webpack_public_path__ + "img/senderrand-runner-step-3.69dc6068.svg";